import { trackDashboardEvent } from '@modules/dashboard/helpers';
import { Box, Drawer, Stack, Typography } from '@mui/material';
import { useEffect } from 'react';

import { DashboardShareDrawerCopyLink } from '../DashboardShareDrawerCopyLink';
import { DashboardShareDrawerInviteCollaborators } from '../DashboardShareDrawerInviteCollaborators';

interface DashboardShareDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  onCopyDashboardLink: () => void;
}

export const DashboardShareDrawer = ({
  isOpen,
  onClose,
  onCopyDashboardLink,
}: DashboardShareDrawerProps) => {
  const closeDrawer = () => {
    onClose();

    trackDashboardEvent({
      eventName: 'Dashboard Share Dialog Closed',
      dashboardLink: window.location.href,
    });
  };

  useEffect(() => {
    if (isOpen) {
      trackDashboardEvent({
        eventName: 'Dashboard Share Dialog Opened',
        dashboardLink: window.location.href,
      });
    }
  }, [isOpen]);

  return (
    <Drawer anchor="right" open={isOpen} onClose={closeDrawer}>
      <Box
        sx={{
          width: '40vw',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          flex: 1,
        }}
      >
        <Box
          sx={{
            pl: 3,
            py: 2,
            width: '100%',
            borderBottom: '1px solid',
            borderColor: 'divider',
          }}
        >
          <Typography variant="h6">Share Dashboard</Typography>
        </Box>
        <Stack sx={{ py: 4 }} spacing={6}>
          <DashboardShareDrawerCopyLink
            onCopyDashboardLink={onCopyDashboardLink}
          />
          <DashboardShareDrawerInviteCollaborators closeDrawer={closeDrawer} />
        </Stack>
      </Box>
    </Drawer>
  );
};
